var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Pagination, Table as AntdTable } from 'antd';
import clsx from 'clsx';
export var Table = function (_a) {
    var _b = _a.customPagination, customPagination = _b === void 0 ? false : _b, paginationProps = _a.paginationProps, tableProps = _a.tableProps;
    if (!customPagination) {
        return _jsx(AntdTable, __assign({ className: 'tableStyle' }, paginationProps, tableProps), void 0);
    }
    return (_jsxs(_Fragment, { children: [_jsx(AntdTable, __assign({ pagination: false, className: 'tableStyle' }, tableProps), void 0), _jsx(Pagination, __assign({ className: clsx('flex-end', 'verticalMargin'), defaultCurrent: 1, showSizeChanger: false, pageSize: 10 }, paginationProps), void 0)] }, void 0));
};
